import { render, staticRenderFns } from "./supplierAgingAnalysis.vue?vue&type=template&id=d85d7dee"
import script from "./supplierAgingAnalysis.vue?vue&type=script&lang=js"
export * from "./supplierAgingAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports